import ErrorBoundary from "../../../Shared/Components/ErrorBoundary"
import Footer2 from "../../../Shared/Components/Footer/Footer2"
import Header2 from "../../../Shared/Components/Header/Header-2"
import CacheProvider from "../../../Shared/cache/cacheProvider"
import Loader from '../../../Shared/Components/Loader/Loader'
import { useEffect, useState } from "react"
import { changeImageSrcToCdn } from "../../../Shared/helper/helper"
import { Helmet } from "react-helmet"
import { getMetaData } from "../../../Shared/service"
import { useLocation } from "react-router-dom"
import { sendEvent } from "../../../Shared/service/eventService"
import { generateEventPageName } from "../../../Shared/helper/helper"

const LandingPageLayout = (props) => {
  const [metaData, setMetData] = useState({});
  const location = useLocation();
  // let pathName = (location.pathname).replace('/', '');
  // pathName = pathName ? pathName : 'homepage';
  // const currentPageMetaData = metaData[pathName];
  // const fetchMetaData = () => {
  //   getMetaData().then((res) => {
  //     setMetData(JSON.parse(res?.data?.packageHtml))
  //   }).catch((err) => console.log(err))
  // }

  useEffect(() => {
    let imgList = document.getElementsByTagName("img");
    // fetchMetaData();
    changeImageSrcToCdn(imgList);
    sendEvent({
      "eventType": "page_view",
      "page_name": generateEventPageName(location.pathname)
    })
  }, []);

  return (
    <div className="landing-page-layout">
      <CacheProvider>
        {/* {currentPageMetaData && <Helmet>
          <title>{currentPageMetaData?.title}</title>
          <meta name="name" content={pathName} />
          <meta name="og:description" content={currentPageMetaData?.description} />
          <meta name="og:url" content={pathName} />
          <meta name="og:title" content={currentPageMetaData?.title} />
        </Helmet>} */}
        <Loader />
        <Header2/>
        <ErrorBoundary>
          {props.children}
        </ErrorBoundary>
        <Footer2/>
      </CacheProvider>
    </div>
  )
}

export default LandingPageLayout;